import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const useGetNewsletterById = (id: number) => {
  const get = useTypedApiClient({
    path: '/admin/newsletters/{id}',
    method: 'get',
  })

  return useQuery({
    queryKey: ['/admin/newsletters', id],
    queryFn: async () => {
      const { data } = await get({ id })
      return data
    },
  })
}
